import { FieldArrayWithId, UseFieldArrayReturn } from 'react-hook-form';

import { ManageCustomCategoriesFormValues } from './ManageCustomCategoriesFormProvider';
import { MANAGE_CUSTOM_CATEGORIES_FORM_FIELD_NAMES } from './ManageCustomCategoriesModal.constants';

export enum ManageCustomCategoriesConfirmationType {
  None = 'None',
  DeleteCategory = 'DeleteCategory',
  UnsavedChanges = 'UnsavedChanges',
}

export type CategoriesFieldName = typeof MANAGE_CUSTOM_CATEGORIES_FORM_FIELD_NAMES.CATEGORIES;

export type CategoriesFieldArray = UseFieldArrayReturn<
  ManageCustomCategoriesFormValues,
  CategoriesFieldName
>;

export type CategoryFieldToDelete = FieldArrayWithId<
  ManageCustomCategoriesFormValues,
  CategoriesFieldName
> & {
  index: number;
};
